var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.loading,style:(( _obj = {
    fontSize: _vm.size ? (_vm.size + "px") : null,
    backgroundColor: _vm.backgroundColor
  }, _obj['--loading-color'] = _vm.color, _obj ))},[_c('div',{class:_vm.$style.spinner},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])])}
var staticRenderFns = []

export { render, staticRenderFns }